/**
 * Ad-platform conversion pixels (X, Taboola).
 *
 * Safe during prerender (react-snap) and when a pixel script is blocked: a
 * missing global is a no-op, never a throw. Callers own de-duplication — checkout
 * guards on a Stripe session id; the quiz and /start email forms on a form submit.
 *
 * Event IDs come from X Ads Manager > Events Manager. The checkout event must be
 * created there and its ID set in REACT_APP_X_CHECKOUT_EVENT_ID (see
 * .env.production and docs/x-ads-setup-runbook.md).
 */

// Quiz Lead event; also used by /start email signups (see trackStartLead).
const X_QUIZ_LEAD_EVENT = 'tw-r2iei-r2mbf';

// Also hardcoded in public/index.html and app/templates/index.html — keep in sync.
const TABOOLA_ACCOUNT_ID = 1987223;

function fireX(eventId) {
  if (!window.twq || !eventId) return;
  try {
    window.twq('event', eventId, {});
  } catch (err) {
    console.error('X pixel failed:', err);
  }
}

function fireTaboola(name) {
  if (!window._tfa) return;
  try {
    window._tfa.push({ notify: 'event', name, id: TABOOLA_ACCOUNT_ID });
  } catch (err) {
    console.error('Taboola pixel failed:', err);
  }
}

/** Quiz email captured — Campaign A's optimisation event. */
export function trackQuizLead() {
  fireX(X_QUIZ_LEAD_EVENT);
  fireTaboola('lead_submit');
}

/** /start email signup (board or weekly results) — shares the quiz Lead event (#310). */
export function trackStartLead() {
  fireX(X_QUIZ_LEAD_EVENT);
}

/**
 * Stripe checkout completed. The trial requires a card, so this is both
 * "trial started" and the revenue event.
 *
 * Read at call time, not module scope, so the value is testable and a build
 * that shipped without it can be diagnosed from the console.
 */
export function trackCheckoutComplete() {
  const eventId = process.env.REACT_APP_X_CHECKOUT_EVENT_ID || '';
  if (!eventId) {
    console.error('REACT_APP_X_CHECKOUT_EVENT_ID unset — checkout conversion NOT tracked');
    return;
  }
  fireX(eventId);
}
